/* Pure parts of the policy editor (design eval F18): who the author is, and
   what an edit changes against the saved version. */
import type { FieldChange } from './PolicyReviewParts';

export interface PolicyFormValues {
    name: string;
    description: string;
    regoContent: string;
    allowCIDRs: string[];
    denyCIDRs: string[];
    sampleInput: string;
}

/** The signed-in user as recorded in created_by / updated_by: email first,
    then display name, then subject. Null when nobody is signed in, so a
    save can refuse rather than write a made-up author like 'admin'. */
export function authorOf(user: { email?: string; name?: string; subject?: string } | null | undefined): string | null {
    const v = user?.email?.trim() || user?.name?.trim() || user?.subject?.trim();
    return v || null;
}

const list = (xs: string[]) => xs.join(', ');

/** Field-level changes, Rego excluded (it gets a line diff). */
export function fieldChanges(before: PolicyFormValues, after: PolicyFormValues, isAcl: boolean): FieldChange[] {
    const out: FieldChange[] = [];
    if (before.name.trim() !== after.name.trim()) out.push({ field: 'Name', before: before.name, after: after.name.trim() });
    if (before.description.trim() !== after.description.trim()) {
        out.push({ field: 'Description', before: before.description, after: after.description.trim() });
    }
    if (isAcl) {
        if (list(before.allowCIDRs) !== list(after.allowCIDRs)) out.push({ field: 'Allowed CIDRs', before: list(before.allowCIDRs), after: list(after.allowCIDRs) });
        if (list(before.denyCIDRs) !== list(after.denyCIDRs)) out.push({ field: 'Denied CIDRs', before: list(before.denyCIDRs), after: list(after.denyCIDRs) });
    } else if (before.sampleInput.trim() !== after.sampleInput.trim()) {
        out.push({ field: 'Sample input', before: before.sampleInput.trim(), after: after.sampleInput.trim() });
    }
    return out;
}
